export default function (http) {
    return {


        queryByPage(data) {
            return http.json({
                url: `/sys/upgrade/query?pageNum=${data.pageNum}&pageSize=${data.pageSize}`,
                data
            });
        },


        getInfo(data) {
            return http.json({
                url: `/sys/upgrade/get?id=${data.id}`,
                data
            })
        },

        saveInfo(data) {
            return http.json({
                url: `/sys/upgrade/save`,
                data
            })
        },

    }
}





// WEBPACK FOOTER //
// ./src/configure/http/api/enroll/upgrade.js